import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import { VStack } from "@/components/ui/vstack";
import { HStack } from "@/components/ui/hstack";
import React, { useEffect, useState } from 'react';
// import { studioVersion } from "../../algorithms_and_functions/studioVersion";
import { FlatList } from "react-native";
import { IconM } from '@/components/media/IconsV2';

import { ContactCard, ContactCardHeader } from "../basic/ContactCard";

export default function ContactCardGroup({ subtitle, search, entries, entriesMaxRows, entryHeader, hasNarrowSidebar }) {
  console.log('ContactCardGroup entries:', entriesMaxRows, entries, hasNarrowSidebar);
  const filtered_entries = (!search ? entries : entries.filter((entry) => {
    let searchable = '';

    switch (true) {
      case 'workflow' in entry:
        searchable += entry.workflow.title;
        searchable += entry.workflow.description;
        break;
      case 'user' in entry:
        searchable += entry.user.name;
        searchable += entry.user.preferredName;
        searchable += entry.user.mail;
        searchable += entry.user.description;
        break;
      case 'toUser' in entry:
        searchable += entry.toUser.preferredName;
        searchable += entry.toUser.mail;
        break;
      case 'channel' in entry:
        searchable += entry.channel.name;
        searchable += entry.channel.description;
        break;
    }

    return searchable.toLowerCase().includes(search.toLowerCase());
  })).sort((entryA, entryB) => {
    switch (true) {
      case 'workflow' in entryA:
        return entryA.workflow.title > entryB.workflow.title ? 1 : -1;
      case 'user' in entryA:
        return entryA.user.preferredName > entryB.user.preferredName ? 1 : -1;
      case 'channel' in entryA:
        return entryA.channel.name > entryB.channel.name ? 1 : -1;
      default:
        return 0;
    }
  }).map(entry => {
     let keys = [];
     keys.push(entry.user?.id)
     keys.push(entry.workflow?.id)
     keys.push(entry.toUser?.id)
     keys.push(entry.channel?.id)
     entry.key = keys.filter(key => !!key).join('_')
     return entry
  })

  const template_row_start = subtitle ? (
    <Text className="text-xl font-medium text-secondary-900">{subtitle}</Text>
  ) : undefined;

  const template_row_end = entriesMaxRows ? (
    <>
      {/* Requires use of `ScrollView` */}
      {/* <Pressable onPress={() => { }} disabled="true">
        <HStack space='xs' alignItems='center'>
          <IconM className='text-secondary-900' size={24} name='keyboard-arrow-left' />
        </HStack>
      </Pressable>
      <Pressable onPress={() => { }} disabled="true">
        <HStack space='xs' alignItems='center'>
          <IconM className='text-secondary-900' size={24} name='keyboard-arrow-right' />
        </HStack>
      </Pressable> */}
    </>
  ) : undefined;

  const template_flatlist = (
    <HStack
      // FIXME(@Milo): The 306px (the sidebar) and 1100px (the main content) should be a `var` too.
      // width='calc(100vw - 306px)' px='max(0rem, calc((100vw - 306px - 1100px) / 2 - var(--space-10)))'
      // {...(hasNarrowSidebar
      //   ? { width: 'calc(100vw - 200px)', px: 'max(0rem, calc((100vw - 200px - 1100px) / 2 - var(--space-10)))' }
      //   : { width: 'calc(100vw - 306px)', px: 'max(0rem, calc((100vw - 306px - 1100px) / 2 - var(--space-10)))' }
      // )}
      // className={` ${entriesMaxRows ? "overflow-auto" : "overflow-hidden"} pb-4 `}
      >
      <HStack className={` ${!entriesMaxRows && 'w-[100%]'} flex-none`}>
        <FlatList
          data={filtered_entries}
          keyExtractor={(entry) => entry.key}
          contentContainerStyle={entriesMaxRows
            ? { flexDirection: "row", }
            : { flexDirection: "row", flexWrap: "wrap", maxWidth: "100%" }
          }
          renderItem={({ item, index }) => {
            return <ContactCard entry={item} key={`${item.key}`} />;
          }}
          {...(entryHeader && {
            ListHeaderComponent: () => (
              <ContactCardHeader
                icon={entryHeader.icon}
                subicon={entryHeader.subicon}
                callback={entryHeader.callback}
              />
            )
          })}
        />
      </HStack>
    </HStack>
  );

  return (
    <VStack space='md' className="mt-3">
      {(!!template_row_start || !!template_row_end) && (
        <HStack className="justify-between items-center mx-2">
          <HStack space='md'>{template_row_start}</HStack>
          <HStack space='md'>{template_row_end}</HStack>
        </HStack>
      )}
      {template_flatlist}
    </VStack>
  );
}
